import React from "react";
import AddDataSidebar from "./AddDataSidebar";
import AddDataBodyInput from "./AddDataBodyInput";
import style from "../../style/AddDataBody.module.scss";

function AddDataBody({ setSendData, setSendMediaData }) {
  return (
    <div className={style.container}>
      <AddDataSidebar />
      <AddDataBodyInput
        setSendData={setSendData}
        setSendMediaData={setSendMediaData}
      />
    </div>
  );
}

export default AddDataBody;
